// shared-animations.ts
import { trigger, transition, style, animate, query, group, keyframes, state } from '@angular/animations';

export const expandCollide = trigger('expandCollapse', [
    state('void', style({ height: '0px', overflow: 'hidden', 'padding-top': '0', 'padding-bottom': '0' })),
    state('*', style({ height: '*', overflow: 'hidden', 'padding-top': '*', 'padding-bottom': '*' })),
    transition(':enter', [
        animate('0.5s ease-out')
    ]),
    transition(':leave', [
        animate('0.5s ease-in')
    ])
]);

export const expandHeight = trigger('expandHeight', [
    transition(':enter', [
        style({ height: '0px', opacity: 0 }),
        animate('600ms ease-out', keyframes([
            style({ height: '*', opacity: 0, offset: 0.8 }),
            style({ height: '*', opacity: 1, offset: 1 })
        ]))
    ]),
]);

export const stepAnimation = trigger('stepAnimation', [
    transition('* <=> *', [
        group([
            query(':enter', [
                style({ opacity: 0, height: '0px' })
            ], { optional: true }),
            query(':leave', [
                style({ opacity: 1 }),
                animate('300ms ease-out', style({ opacity: 0 }))
            ], { optional: true })
        ]),
        group([
            query(':leave', [
                style({ height: '0px' })
            ], { optional: true }),
            query(':enter', [
                style({ height: '*' }),
                animate('300ms ease-out', style({ opacity: 1 }))
            ], { optional: true }),
        ]),
    ])
]);

export const slideStepAnimation = trigger('slideStepAnimation', [
    transition(':increment', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
    ]),
    transition(':decrement', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
    ])
]);

export const slideHorizontal = trigger('slideHorizontal', [
    state('open', style({
        width: '*',
        opacity: 1,
        overflow: 'hidden'
    })),
    state('closed', style({
        width: '0',
        opacity: 0,
        overflow: 'hidden'
    })),
    transition('open <=> closed', [
        animate('300ms ease-in-out')
    ])
]);

export const rotateChevron = trigger('rotateChevron', [
    state('open', style({
        transform: 'rotate(0deg)'
    })),
    state('closed', style({
        transform: 'rotate(180deg)'
    })),
    transition('open <=> closed', [
        animate('300ms ease-in-out')
    ])
]);